import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { type CallCenterTourStep } from "./entity";

export const CallCenterTourStepEntityConfig: HyperEntityConfig<CallCenterTourStep> =
  {
    caption: "שלבי סיור מוקד",
    allowApiRead: Roles.AdminsAndManager,
    allowApiCrud: Roles.AdminsAndManager,
    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;

      filter(Roles.SuperDuperAdmin, false);
      filter(Roles.SuperAdmin, true);
      filter(Roles.OrganizationManagers, {
        organization: {
          $id: remult.user.organizationId,
        },
      });
      filter(Roles.User, false);
    },
    allowInsertPerRole(allow) {
      allow(Roles.OrganizationManagers, (entity) =>
        entity.organizationId === remult.user!.organizationId,
      );
    },
    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.OrganizationManagers, {
        organization: {
          $id: remult.user!.organizationId,
        },
      });
    },
  };
